const $$splitComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/dash/catalog/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFilterConfig } from '@/Components/filterbar';
import { createFileRoute } from '@tanstack/react-router';
type ViewType = 'grid' | 'list' | undefined;
const CatalogFilterConfig = createFilterConfig({
  routeId: '/dash/catalog/',
  options: {
    restoreOnMount: true
  }
}, {
  search: true,
  mediaName: true,
  visibility: true,
  author: true,
  category: true,
  tags: true,
  date: true,
  order: true
});
export type CatalogFilterConfigType = typeof CatalogFilterConfig;
export const Route = createFileRoute('/dash/catalog/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr),
  validateSearch: CatalogFilterConfig.filterSearchValidator
});